export const SET_LAUNCHDARKLY_FLAGS = 'SET_LAUNCHDARKLY_FLAGS';
